import React from "react";
import LogoUI from "./LogoUI";

const Logo = () => {
  return <LogoUI />;
};

export default Logo;
